import React from 'react'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux'
import ContactIssueSelector from './ContactIssueSelector'
import ContactIssueContentList from './ContactIssueContentList'
import ContactSearch from './ContactSearch'

const ContactSelfHelp = (props) => {
  const breadcrumb = useSelector((state) => state.breadcrumb.value)

  const handleStillNeedHelpClick = () => {
    // Analytics: Fire event48 when Still Need Help CTA is clicked
    s.events = "event48";
    s.tl();
  }

  return (
    <div id="self-help">
      <ContactIssueSelector
        contentSelfHelp = {props.contentSelfHelp}
        contentStrings = {props.contentStrings}
      />

      {
        (breadcrumb === "review") ?
          <>
            <ContactIssueContentList
              contentSelfHelp = {props.contentSelfHelp}
              contentStrings = {props.contentStrings}
              relativeUrl = {props.relativeUrl}
            />

            <ContactSearch
              contentStrings = {props.contentStrings}
              relativeUrl = {props.relativeUrl}
              updateIntent = {props.updateIntent}
            />

            <Link to={props.relativeUrl+"/options"} onClick={handleStillNeedHelpClick}>
              <div id="contact-intent-still-need-help-btn">{props.contentStrings['review-still-need-help']}</div>
            </Link>
          </>
         : ""
      }
    </div>
  )
}
export default ContactSelfHelp